import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const NoResultSearch = () => {
  const { t } = useTranslation()

  return (
    <Box paddingX="20px" marginTop="50%" minHeight="100vh">
      <Typography
        lineHeight="3rem"
        component="h2"
        fontSize="2.4rem"
        fontWeight="600"
        color={'baseColor.colorText1'}>
        {t('titles.search_empty')}
      </Typography>
      <Typography
        lineHeight="2rem"
        fontSize="1.6rem"
        fontWeight="400"
        component="p"
        color={'baseColor.colorText1'}>
        {t('descriptions.search_empty')}
      </Typography>
    </Box>
  )
}

export default React.memo(NoResultSearch)
